import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { addDays, format, parseISO } from 'date-fns';
import selectPerson from '@/components/select-person/genera';
import { queryOrganByUser, queryPositionByUser } from '@/api/commonApi.js';
import { queryNoticeFill, queryNoticeCate, withdrawNotice as _withdrawNotice, delNotice as _delNotice, releaseNotice as _releaseNotice, submitNotice as _submitNotice, addAppendAudit, querySign } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '紧急状态',
      dataIndex: 'emergency',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'emergency'
      }
    }, {
      title: '公告分类',
      dataIndex: 'cateName',
      align: 'center',
      width: 100
    }, {
      title: '公告标题',
      dataIndex: 'title',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '是否置顶',
      dataIndex: 'isTop',
      align: 'center',
      width: 80,
      customRender: function customRender(isTop) {
        if (0 === isTop) {
          return '否';
        } else if (1 === isTop) {
          return '是';
        } else {
          return '';
        }
      }
    }, {
      title: '拟稿人',
      dataIndex: 'drafterTemp',
      align: 'center',
      width: 180,
      scopedSlots: {
        customRender: 'drafterTemp'
      }
    }, {
      title: '拟稿时间',
      dataIndex: 'createTime',
      ellipsis: true,
      align: 'center',
      width: 100
    }, {
      title: '发布范围',
      dataIndex: 'range',
      ellipsis: true,
      align: 'center',
      width: 100,
      customRender: function customRender(range) {
        if (0 === range) {
          return '全校教职工';
        } else if (1 === range) {
          return '自定义';
        } else if (2 === range) {
          return '当前组织层级';
        } else if (3 === range) {
          return '当前组织层级指定人员';
        } else {
          return '';
        }
      }
    }, {
      title: '公告状态',
      dataIndex: 'noticeStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'noticeStatus'
      }
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    var userTabList = [{
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return {
      userTabList: userTabList,
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      expand: false,
      cateList: [],
      where: {
        cateId: undefined,
        emergency: '',
        startAndEndTime: [],
        title: '',
        startTime: '',
        endTime: ''
      },
      data: [],
      pagination: this.$hdk.page(),
      appendTitle: '追加审核',
      visibleMode: false,
      modalLoading: false,
      selectOption: '',
      appendFormObj: {
        isAppend: '',
        // 是否追加审核 0 无 1 追加 2前签 3后签
        fillId: '',
        // 公告id
        records: [{
          appendname: '',
          organid: '',
          // 组织id
          typeid: '',
          // 组织类型
          userid: undefined,
          // 审核人
          postid: undefined,
          // 岗位id
          sort: '',
          // 岗位id
          customize: {
            postData: [],
            userData: []
          }
        }]
      },
      optionData: [],
      postList: [],
      // 岗位数据
      formObject: {},
      signRecord: [],
      templateSelect: false
    };
  },
  created: function created() {
    var fetch = this.fetch,
      getNoticeCate = this.getNoticeCate;
    fetch();
    getNoticeCate();
  },
  methods: {
    /*
     * 根据条件搜索通知公告
     */
    fetch: function fetch(options) {
      var _this = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;

      // 日期格式化
      if (where.startAndEndTime.length > 0) {
        this.where.startTime = parseISO(format(where.startAndEndTime[0]._d, 'yyyy-MM-dd'));
        this.where.endTime = parseISO(format(where.startAndEndTime[1]._d, 'yyyy-MM-dd'));
      } else {
        this.where.startTime = null;
        this.where.endTime = null;
      }
      if (!pager.where) {
        pager.where = where;
      }
      queryNoticeFill(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /*
     * 公告分类
     */
    getNoticeCate: function getNoticeCate() {
      var _this2 = this;
      queryNoticeCate().then(function (res) {
        _this2.cateList = res.data.data;
      });
    },
    /*
     * 撤回通知公告
     */
    withdrawNotice: function withdrawNotice(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认撤回吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _withdrawNotice(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('撤回成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /*
     * 删除通知公告
     */
    delNotice: function delNotice(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _delNotice(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /*
     * 发布通知公告
     */
    releaseNotice: function releaseNotice(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认发布吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _releaseNotice(row.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('发布成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /*
     * 提交通知公告
     */
    submitNotice: function submitNotice(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认提交吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _submitNotice(row).then(function (res) {
          if (res.data.code == 200) {
            $message.success('提交成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    /*
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /*
     * 打开通过公告选择模板
     */
    addNotice: function addNotice() {
      this.templateSelect = true;
    },
    // 通知公告选择模板确定事件
    chooseTemplate: function chooseTemplate(flag) {
      this.$router.push({
        path: '/docNotice/notice/noticeAdd',
        query: {
          flag: flag
        }
      });
    },
    closeSelectTemp: function closeSelectTemp() {
      this.templateSelect = false;
    },
    /*
     * 编辑通知公告
     */
    editNotice: function editNotice(row) {
      this.$router.push({
        path: '/docNotice/notice/noticeAdd',
        query: {
          flag: row.isCehck,
          id: row.id,
          type: 1
        }
      });
    },
    /*
     * 查看通知公告
     */
    viewNotice: function viewNotice(row) {
      if (0 === row.noticeStatus) {
        this.$router.push({
          path: '/docNotice/notice/noticeAdd',
          query: {
            id: row.id,
            type: 2
          }
        });
      } else {
        this.$router.push({
          path: '/docNotice/notice/auditNotice',
          query: {
            id: row.id,
            type: 4
          }
        });
      }
    },
    /**
     * 追加审核保存
     */
    handleOk: function handleOk() {
      var _this3 = this;
      var $refs = this.$refs,
        $message = this.$message,
        appendFormObj = this.appendFormObj,
        fetch = this.fetch;
      if (appendFormObj.records.length === 0) {
        $message.error('请添加数据');
        return;
      }
      $refs.addForm.validate(function (valid) {
        if (valid) {
          // 选择的成员或者岗位数据处理
          _.map(appendFormObj.records, function (item) {
            if (item.customize.userData.length > 0) {
              item.organid = item.customize.userData[0].organId;
              item.postid = item.customize.userData[0].postId;
              item.typeid = item.customize.userData[0].typeId;
              item.userid = item.customize.userData[0].actorId;
            }
            if (item.customize.postData.length > 0) {
              item.organid = item.customize.postData[0].organId;
              item.typeid = item.customize.postData[0].typeId;
              item.postid = item.customize.postData[0].actorId;
            }
          });
          _this3.modalLoading = true;
          addAppendAudit(_objectSpread({}, appendFormObj)).then(function (res) {
            if (res.data.code == 200) {
              $message.success('保存成功');
              _this3.visibleMode = false;
              fetch();
            }
            _this3.modalLoading = false;
          });
        }
      });
    },
    /**
     * 追加审核弹框
     */
    appendAudit: function appendAudit(row, flag) {
      var _this4 = this;
      var $set = this.$set,
        $refs = this.$refs,
        appendFormObj = this.appendFormObj,
        userInfo = this.userInfo;
      // 清除校验
      if ($refs.addForm) {
        $refs.addForm.clearValidate();
      }
      this.visibleMode = true;
      // 是否追加审核 0 无 1 追加 2前签 3后签
      if (flag === 2) {
        this.appendTitle = '加前签';
      } else if (flag === 3) {
        this.appendTitle = '加后签';
      }

      // 数据赋值
      $set(appendFormObj, 'isAppend', flag);
      $set(appendFormObj, 'fillId', row.id);
      this.appendFormObj.records = [{
        appendname: '',
        organid: '',
        typeid: '',
        userid: undefined,
        postid: '',
        sort: 1,
        customize: {
          postData: [],
          userData: []
        }
      }];
      // 查询加签记录指定排序
      querySign({
        fillId: row.id,
        appendType: flag
      }).then(function (res) {
        _this4.signRecord = res.data.data;
        // 排序计算
        if (_this4.signRecord.length > 0) {
          var sorts = [];
          _.forEach(_this4.signRecord, function (item, key) {
            return sorts.push(item.sort);
          });
          _this4.appendFormObj.records[0].sort = _.max(sorts) + 1;
        }
      });
    },
    addDomain: function addDomain() {
      var appendFormObj = this.appendFormObj,
        signRecord = this.signRecord;

      // 排序计算
      var sorts = [];
      _.forEach(appendFormObj.records, function (item, key) {
        return sorts.push(item.sort);
      });

      // 加签记录排序计算
      if (appendFormObj.records.length === 0 && signRecord.length > 0) {
        _.forEach(signRecord, function (item, key) {
          return sorts.push(item.sort);
        });
      }
      this.appendFormObj.records.push({
        appendname: '',
        organid: '',
        typeid: '',
        userid: undefined,
        postid: '',
        sort: _.max(sorts) ? _.max(sorts) + 1 : 1,
        customize: {
          postData: [],
          userData: []
        }
      });
    },
    removeDomain: function removeDomain(item) {
      var signRecord = this.signRecord,
        appendFormObj = this.appendFormObj;
      var index = this.appendFormObj.records.indexOf(item);
      if (index !== -1) {
        this.appendFormObj.records.splice(index, 1);
      }
      var sorts = [0];
      // 加签记录排序计算
      if (signRecord.length > 0) {
        _.forEach(signRecord, function (item, key) {
          return sorts.push(item.sort);
        });
      }

      // 删除计算自动排序
      _.forEach(appendFormObj.records, function (row, key) {
        row.sort = _.max(sorts) + (key + 1);
      });
    },
    onClose: function onClose() {
      this.visibleMode = false;
    },
    /**
     * 级联选择value, option
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var _this5 = this;
      var $set = this.$set,
        getPositionByUser = this.getPositionByUser,
        getOrganByUser = this.getOrganByUser;
      if (value.length === 0) {
        this.optionData = [];
      }

      // 获取岗位数据
      this.postList = [];
      _.forEach(option, function (item) {
        if (item.postAll) {
          _.forEach(item.postAll, function (post) {
            _this5.postList.push(post);
          });
        }
      });
      // 组织赋值取最后一级
      if (value.length > 0) {
        this.typeId = option[value.length - 1].typeId;
        this.organId = value[value.length - 1];
      } else {
        this.typeId = '';
        this.organId = '';
      }
    },
    popupVis: function popupVis(row) {
      var typeId = this.typeId,
        organId = this.organId;
      if (organId) {
        row.organid = organId;
        row.typeid = typeId;
      } else {
        row.organid = '';
        row.typeid = '';
        row.postid = undefined;
        row.userid = undefined;
      }
    },
    postSelect: function postSelect(value, option) {
      var $set = this.$set,
        typeId = this.typeId,
        organId = this.organId,
        postId = this.postId,
        formObject = this.formObject,
        getPositionByUser = this.getPositionByUser,
        getOrganByUser = this.getOrganByUser;
      $set(formObject, 'organId', organId);
      $set(formObject, 'postId', value);
      getPositionByUser();
    },
    postChange: function postChange(row) {
      if (!row.postid) {
        row.userid = undefined;
      }
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 根据组织查询人员
     */
    getPositionByUser: function getPositionByUser() {
      var _this6 = this;
      var $refs = this.$refs,
        $set = this.$set,
        formObject = this.formObject;
      queryPositionByUser({
        organId: formObject.organId,
        postId: formObject.postId
      }).then(function (res) {
        _this6.optionData = res.data.data;
      });
    }
  },
  components: {
    selectPerson: selectPerson
  }
};